module.exports = __webpack_public_path__ + "cae9a0777068ceb68b16382adf439e80.pdf";